import './ReturnLabelUploadPage.css'

import { useEffect, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { updatePackageReq } from '../../../api/package-req/packageReqService'
import returnIcon from '../../../imgs/next.png'
import { uploadFile } from '../../../services/files'
import { setPackageForReturnLabelUpload } from '../../../store/packageSlice'

export default function ReturnLabelUploadPage() {
  const history = useHistory()
  const packageForReturnLabelUpload = useSelector(state => state.packages.packageForReturnLabelUpload)
  //UI & terms
  const [showImgView, setshowImgView] = useState(false)
  const [isLoadingSubmit, setisLoadingSubmit] = useState(false)
  const [showErrorModal, setshowErrorModal] = useState(false)
  const [errorModalText, seterrorModalText] = useState('')

  //receipt data
  const [receiptFileURL, setreceiptFileURL] = useState()
  const [receiptFile, setreceiptFile] = useState()
  const [dotFileTypeState, setdotFileTypeState] = useState()

  //in case of refresh. we want the user to start over.
  useEffect(() => {
    if (packageForReturnLabelUpload == null) {
      history.push(`/personal-info`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const receiptViewHandler = async e => {
    setshowImgView(false)
    document.getElementById('adobe-pdf-view').innerHTML = ''
    const file = e.target.files[0]
    if (!file) return

    //check for allowed files formats
    const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
    if (!allowedFileTypes.includes(file.type)) {
      seterrorModalText('ניתן להעלות תווית כתמונה או כPDF בלבד.')
      setshowErrorModal(true)
      return
    }

    setreceiptFile(file)
    let dotFileType = file.name
    dotFileType = dotFileType.substring(dotFileType.lastIndexOf('.'), dotFileType.length)
    setdotFileTypeState(dotFileType)

    // diffrent UI for image and PDF
    if (dotFileType !== '.pdf') {
      setreceiptFileURL(URL.createObjectURL(file))
      setshowImgView(true)
    } else {
      // Adobe API code (Adobe PDF Embed API)
      // eslint-disable-next-line no-undef
      var adobeDCView = new AdobeDC.View({ clientId: '3daf1a0430a045879e5bf8163cad53c3', divId: 'adobe-pdf-view' })
      var reader = new FileReader()
      reader.onloadend = function (e) {
        var filePromise = Promise.resolve(e.target.result)
        // Pass the filePromise and name of the file to the previewFile API
        adobeDCView.previewFile(
          {
            content: { promise: filePromise },
            metaData: { fileName: file.name },
          },
          { embedMode: 'IN_LINE' }
          // { defaultViewMode: 'SINGLE_PAGE' }
        )
      }
      reader.readAsArrayBuffer(file)
    }
  }

  const submitHandler = async () => {
    //check for allowed files formats
    const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
    if (!allowedFileTypes.includes(receiptFile.type)) {
      seterrorModalText('ניתן להעלות תווית כתמונה או כPDF בלבד.')
      setshowErrorModal(true)
      return
    }

    try {
      setisLoadingSubmit(true)
      //upload receipt to S3
      const result = await uploadFile(receiptFile, packageForReturnLabelUpload.id + dotFileTypeState)
      // console.log('submitHandler - params.updateParam.result.Location:', result.Location)

      //check if lable uploaded (not really needed but to make sure)
      if (!result.Location) throw 'link to label not found'

      //save label to package req
      const data = {
        packageReqId: packageForReturnLabelUpload.returnRequestId,
        returnLabel: result.Location,
      }
      await updatePackageReq(data)

      setPackageForReturnLabelUpload(null)
      history.push(`/personal-info/myPackages`)

      setisLoadingSubmit(false)
    } catch (error) {
      setisLoadingSubmit(false)
      console.log('Error: ', error)

      seterrorModalText('הייתה שגיאה בבקשה. אנא נסה שנית או פנה לשירות הלקוחות.')
      setshowErrorModal(true)
    }
  }

  if (packageForReturnLabelUpload == null) {
    return <div></div>
  }

  return (
    <div className='rlp-container'>
      <div className='rlp-return-cont' onClick={() => history.push('/personal-info/myPackages')}>
        <img src={returnIcon} className='rlp-return-img' />
        <div>חזרה לחבילות שלי</div>
      </div>
      <h2 className='rlp-page-title'>החזרת חבילה</h2>
      <br />
      <div
        className='btn yellow-bcg'
        onClick={() => {
          document.getElementById(`receiptInput`).click()
        }}
      >
        העלאת תווית החזרה
      </div>
      <input type='file' id={'receiptInput'} style={{ display: 'none' }} onChange={receiptViewHandler} />

      <div className='rlp-file-view-cont'>
        {showImgView && <img src={receiptFileURL} alt='receipt-view' />}
        <div id='adobe-pdf-view' className='adobe-pdf-view'></div>
      </div>

      {showImgView && (
        <div className='rlp-bottom-cont'>
          <div style={{ height: '40px' }}>
            {isLoadingSubmit ? (
              <Spinner animation='border' variant='primary' />
            ) : (
              <Button block disabled={isLoadingSubmit} onClick={submitHandler} variant='primary' style={{ width: '226px' }}>
                אישור העלאה
              </Button>
            )}
          </div>
        </div>
      )}

      <Modal show={showErrorModal} onHide={() => setshowErrorModal(false)} style={{ direction: 'rtl', textAlign: 'center' }}>
        <Modal.Header style={{ textAlign: 'center' }}>
          <div style={{ width: '100%' }}>
            <Modal.Title>שים לב!</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>{errorModalText}</Modal.Body>
        <Modal.Footer style={{ justifyContent: 'center' }}>
          <Button variant='danger' onClick={() => setshowErrorModal(false)}>
            סגור
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
